// css文件中不要使用import
/**
 * 参数
 * oauthtype 授权类型，默认qq
 * target_uri 授权完成后的回调地址
 * channel 注册用户的渠道号，如果不传，默认为h5_default
 */
import '../css/reset.css';
import '../css/whatever.css';
import 'babel-polyfill';
import '../css/reset.css';
import '../css/whatever.css';
import env from 'c-nenv';
import url from 'c-url';
import token from './token';
import Cache from 'c-cache';
import notification from 'c-notification';
import sns, { fb, twitter } from './sns/index';
import FaskClick from 'c-fastclick';
import './SM';
import _ from 'underscore';
import ProfileGet from './profile/get';

const _lang = url.query('lang') || 'zh-TW';

const cache = new Cache({
    prefix: 'uplive'
});

const textMap = {
    'zh-TW': {
        tip: '在使用Gifto錢包前需要先登錄',
        btn: '立刻登錄'
    },
    'en-US': {
        tip: 'Please login first before use the Gifto Wallet.',
        btn: 'Login now!'
    }
};

let getTextFromJSON = (key)=>{
    let langObj = textMap[_lang];
    if (!langObj) {
        langObj = textMap['zh-TW'];
    }

    return langObj[key];
};

FaskClick.attach(document.body);



class Login {

    constructor() {
        this.code = url.query('code');
        this.platform = env.platform.name;
        this.oauthtype = url.query('oauthtype');
        if (!this.oauthtype) {
            this.oauthtype = document.domain == 'h5.upliveapp.com' ? 'qq' : 'fb';
        }
        
    }

    init() {
        let domain = document.domain;
        let multiLoginChannel = url.query('multiLoginChannel');
        
        if (multiLoginChannel) {
            switch (this.oauthtype) {
                case 'twitter':
                    this.twitter();
                    break;
                case 'weibo':
                    this.weibo();
                    break;
                case 'fb':
                    this.facebook();
                    break;
                case 'wechat':
                    this.wechat();
                    break;
                case 'qq':
                    this.qq();
                    break;
                default:
                    if (domain == 'h5.upliveapp.com') {
                        this.qq();
                    } else {
                        this.facebook();
                    }
                    break;
            } 
        } else {
            switch (this.platform) {
                case 'wechat':
                    this.wechat();
                    break;
                case 'twitter':
                    this.twitter();
                    break;
                case 'weibo':
                    this.weibo();
                    break;
                case 'facebook':
                    this.facebook();
                    break;
                case 'qq':
                    this.qq();
                    break;
                default:
                    switch (this.oauthtype) {
                        case 'twitter':
                            this.twitter();
                            break;
                        case 'weibo':
                            this.weibo();
                            break;
                        case 'fb':
                        default:
                            if (domain == 'h5.upliveapp.com') {
                                this.qq();
                            } else {
                                this.facebook();
                            }

                            break;
                    }
                    break;

            }
        }

        
    }

    wechat() {
        if (!this.code) {
            sns.jumpToSNS('wechat');
        } else {
            token.get('wechat', this.code);
        }
    }

    twitter() {

        let oauth_token = url.query('oauth_token');
        // 当获取request_token成功后, 则继续跳转到twitter的oauth验证页面获取verifier
        $.channel.on('getTwitterOauthTokenSuccess', (resp) => {
            if (!resp || !resp.oauth_token) {
                notification.simple('get oauth_token fail');
                return;
            }
            sns.twitterJumpForCode(resp.oauth_token);
            cache.setCache('twitter', resp);
        });

        // 当url中不包含oauth_token时
        // 用户首次进入此授权登录页面, 先从java端获取request_token
        if (!oauth_token) {
            twitter.getRequestToken();
        } else {
            // 反之, 已从twitter oauth页面返回并携带oauth_token
            // 此时可获取up usertoken
            token.get('twitter', oauth_token, cache.getCache('twitter').oauth_token_secret, url.query('oauth_verifier'));
        }
    }

    weibo() {
        if (!this.code) {
            sns.weiboJumpForCode();
        } else {
            token.get('weibo', this.code);
        }
    }

    qq() {
        if (!this.code) {
            sns.qqJumpForCode();
        } else {
            token.get('qq', this.code);
        }

    }

    facebook() {

        if (window.FBOauthResponse) {
           
            token.get('facebook', window.FBOauthResponse.accessToken);
        } else {
            if (typeof FB !== 'undefined') {
                FB.login(()=>{
                    fb.checkLoginState();
                    if (window.FBOauthResponse) {
                        token.get('facebook', window.FBOauthResponse.accessToken);
                    }
                });
            }
            
        }
    }
}


function getSMDeviceId() {
    let defer = $.Deferred();
    // 无论是否使用游客，都产生一个smd（数美的deviceId）
    // 并且存储到本地
    let cacheDeviceId = cache.getCache('smDeviceId');

    if (!cacheDeviceId) {

        // 数美JS已经加载完成
        if (typeof SMSdk !== 'undefined') {
            window.smDeviceId = SMSdk.getDeviceId();
            cache.setCache('smDeviceId', window.smDeviceId);
            defer.resolve();
        } else {

            // 否则监听事件，等待sdk加载完成
            $.channel.on('smsdkLoaded', () => {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', smDeviceId);
                defer.resolve();
            });
            
            $.channel.on('smsdkLoadedError', () => {
                defer.resolve();
            })
        }
    } else {
        window.smDeviceId = cacheDeviceId;
        defer.resolve();
    }

    return defer;
}


let login = new Login();

if (login.oauthtype == 'fb') {
    fb.init();
}

// 若本地中已存在user信息
// 先验证user是否已过期
let localUser = cache.getCache('user');

if (localUser) {
    let _getProfile = (uid)=>{
        let profile = new ProfileGet(uid);
        
        profile.promise.done((data)=>{
            // debugger;
            token.back();  
        }).fail((data)=>{
            getSMDeviceId().done(() => {
                if (login.oauthtype != 'fb') {
                    login.init();
                } else {
                    
                    setTimeout(()=>{
                        if (typeof FB !== 'undefined') {
                            renderDom()
                        } else {
                            $.channel.on('fbsdkLoaded', ()=>{
                                renderDom();
                            });
                        }
                    }, 1500);

                }
            });
        });
    }

    _getProfile(localUser.uid);

} else {
    getSMDeviceId().done(() => {
        if (login.oauthtype != 'fb') {
            login.init();
        } else {
            
            setTimeout(()=>{
                if (typeof FB !== 'undefined') {
                    renderDom()
                } else {
                    $.channel.on('fbsdkLoaded', ()=>{
                        renderDom();
                    });
                }
            }, 1500);

        }
    });
}



let renderDom = ()=>{
    let temp = $('#actbtn').html();
    $('#wrap').html(_.template(temp)({
        tip: getTextFromJSON('tip'),
        btn: getTextFromJSON('btn')
    }));

    $('.tip-content button').on('click', ()=>{
        login.init();
    });
};







// WEBPACK FOOTER //
// ./js/app.js